import React from "react";
import "./LoginStyle.scss";

const Login: React.FC = () => {
  const EMAIL = "mytechxpert@michelin.com";

  const DELETE_ACCOUNT_MAIL_SUBJECT = "Account deletion request";

  const MAIL_BODY_CONTENT =
    "Dear MyTechXpert Support Team, \n\nI have an account and associated data in your database with \nName {mention your name here},\nEmail address {mention your email address here} and\nRegistered phone number {mention your phone number here}\n\nMeanwhile, for some reason, I have decided not to use the account again; therefore, I request that you kindly delete my account from your database and delete all the information.";

  const mailtoLink = `mailto:${EMAIL}?subject=${encodeURIComponent(
    DELETE_ACCOUNT_MAIL_SUBJECT
  )}&body=${encodeURIComponent(MAIL_BODY_CONTENT)}`;
  console.log("🚀 ~ mailtoLink:", mailtoLink);

  // const onSubmit = async () => {
  //   console.log("Login button clicked");
  // };

  return (
    <div className="login-container">
      <div className="header-heading-container">
        <h1>Delete MICHELIN MyTechXpert Account and Data</h1>
        <ol>
          <li>
            <strong>Step 1: </strong>Login into MyTechXpert app. On successful
            Login, app will display Home Screen.
          </li>
          <li>
            <strong>Step 2: </strong>On Home Screen, click user profile icon at
            top right corner (profile icon button before log-out button)
          </li>
          <li>
            <strong>Step 3: </strong> Scroll down on profile screen to see
            “Delete Account Request” button. Click on "Delete Account Request”
            that will open up “Delete Account Request” popup
          </li>
          <li>
            <strong>Step 4: </strong> Enter any message (Optional) and Submit.
            On Submit, it will open email composer with pre-filled email
            recipient, subject & message in Body
          </li>
          <li>
            <strong>Step 5: </strong> Send email to MyTechXpert App Team to
            request delete account.
          </li>
        </ol>
        <p className="note">
          Note: Currently, we do not have an automatic process for deleting user
          accounts and their associated data. If you would like to request
          account deletion, please contact us at{" "}
          <a href={mailtoLink}>mytechxpert@michelin.com</a>
        </p>
      </div>
      {/* <div>
        <button className="loginScreenButtton" onClick={() => onSubmit()}>
          Login
        </button>
      </div> */}
    </div>
  );
};

export default Login;
